const labels = {
  checkIn: 'チェックイン',
  checkOut: 'チェックアウト',
  noDates: '日付指定なし',

  peopleCounterPC: '人',
  peopleCounterSP: '名',

  adult: '大人',
  children: '子供',
  childrenUpperGrade: '小学生 高学年',
  childrenLowerGrade: '小学生 低学年',
  infantsMealAndBed: '幼児 食事・布団付',
  infantsMealOnly: '幼児 食事のみ',
  infantsBedOnly: '幼児 布団のみ',
  infantsOnly: '幼児 食事・布団不要',

  childrenBed: 'ベッドあり',
  childrenNoBed: 'ベッドなし',

  numberOfRooms: '部屋数',
  perRoom: '(1部屋あたり)',
  rooms: '部屋',
  pleaseSelect: 'を選択して下さい',
  roomCounter: '室',

  accommodationScheduleNumberOfPeopleCondition: '宿泊日程・人数条件',
  decide: '決定',
  search: '検索',
  searchVacancy: '空室検索',
  numberOfPeople: '宿泊人数',
};

export default labels;
